import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { MessageSquare, Reply } from "lucide-react";

interface NoteFormProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit: (isResponse: boolean) => void;
}

export const NoteForm = ({ value, onChange, onSubmit }: NoteFormProps) => {
  return (
    <div className="space-y-2">
      <Textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Add a new note or response..."
        className="min-h-[100px]"
      />
      <div className="flex gap-2">
        <Button
          onClick={() => onSubmit(false)}
          className="flex items-center gap-2"
        >
          <MessageSquare className="h-4 w-4" />
          Add Note
        </Button>
        <Button
          onClick={() => onSubmit(true)}
          variant="secondary"
          className="flex items-center gap-2"
        >
          <Reply className="h-4 w-4" />
          Add Client Response
        </Button>
      </div>
    </div>
  );
};